import { render, staticRenderFns } from "./mo-radio-wrapper.html?vue&type=template&id=632ec603&scoped=true&external"
import script from "./mo-radio-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-radio-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-radio-wrapper.scss?vue&type=style&index=0&id=632ec603&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632ec603",
  null
  
)

export default component.exports